module.exports = __webpack_public_path__ + "img/snorkeling-15.02eb3317.jpeg";